import { SurveyView } from "../views/Survey/SurveyView";
import { SurveyQuestions } from "../views/Survey/SurveyQuestions";
import DescriptionIcon from "@material-ui/icons/Description";

export const surveysRoutes = [
  {
    collapse: true,
    name: "Encuestas",
    icon: DescriptionIcon,
    state: "surveysSection",
    inSidebar: true,
    isProtected: true,
    rule: "SURVEYS",
    views: [
      {
        path: "/surveys",
        name: "Mantenimiento",
        mini: "MT",
        component: SurveyView,
        layout: "/admin",
        inSidebar: true,
        isProtected: true,
        rule: "SURVEYS",
      },
      {
        path: "/survey/:id",
        name: "Preguntas",
        mini: "PR",
        component: SurveyQuestions,
        layout: "/admin",
        inSidebar: false,
        isProtected: true,
        rule: "SURVEYS",
      },
    ],
  },
]